import React from 'react'
import { Message } from './Message'

const BROKER_RETIREMENT_MESSAGE =
    "The Owner's Edge Portal retired effective July 1, 2026. Please contact your Argo underwriter for Owner's Interest and OCP submissions."

export const CustomOktaError = ({ error }) => {
    let errorMessage = 'Error encountered during Login.' // Default error message
    if (Object.hasOwn(error, 'errorSummary')) {
        errorMessage = error.errorSummary.includes('User is not assigned to the client application')
            ? BROKER_RETIREMENT_MESSAGE
            : error.errorSummary
    }

    return (
        <div className="container">
            <Message title="Error Message" type="warning">
                { errorMessage }
            </Message>
        </div>
    )
}